type CardProps = {
  title: string;
  topic: string;
  icon: any;
};

const AILawyerCard = ({ title, topic, icon }: CardProps) => {
  return (
    <>
      <div className="flex px-3 sm:items-center sm:px-5 [&>svg]:w-6">
        {icon}
        <h3 className="text-subColor3 text-[10px] whitespace-nowrap relative left-3 mini:text-[12px] sm:text-[16px] lg:text-[20px]">
          {topic}
        </h3>
      </div>
      <h4 className="text-subColor5 p-4 text-[9px] mini:text-[12px] sm:text-[14px] lg:text-[20px] mb-8 sm:pl-14">
        {title}
      </h4>
    </>
  );
};

export default AILawyerCard;
